<template>

  <div class="DataConsent">

    <p v-if="content.privacyPolicyNote"
      v-html="insertLink(content.privacyPolicyNote)"
    ></p>

    <!-- 'data-testing-target' attribute is used in Ghost Inspector tests -->
    <ConsentCheckbox v-if="content.privacyPolicyCheckbox"
      data-testing-target="Field: hasAcceptedPrivacyPolicy"
      name="hasAcceptedPrivacyPolicy"
      :value="fieldValues.hasAcceptedPrivacyPolicy"
      :html="insertLink(content.privacyPolicyCheckbox)"
      :error="fieldErrors.hasAcceptedPrivacyPolicy"
    />

    <ConsentCheckbox v-if="content.marketingCheckbox"
      name="hasConsentedToMarketing"
      :value="fieldValues.hasConsentedToMarketing"
      :html="insertLink(content.marketingCheckbox)"
      :error="fieldErrors.hasConsentedToMarketing"
    />

  </div>

</template>

<script>
import ConsentCheckbox from './ConsentCheckbox.vue'

export default {
  components: {
    ConsentCheckbox,
  },
  props: {
    content: Object,
    fieldErrors: Object,
    fieldValues: Object,
  },
  data() {
    return {
      error: null,
    }
  },
  methods: {
    // Turn the url into a link and insert it into the text, returning the resulting HTML string.
    insertLink({ text, url }) {
      const matchResult = text.match(/^(.*)\[(.*)\](.*)$/)
      if (matchResult) {
        const [_, before, link, after] = matchResult
        return `${before}<a href="${url}" target="_blank">${link}</a>${after}`
      }
      return text
    },
  },
}
</script>

<style scoped>

.DataConsent {
  font-weight: 500;
  font-size: var(--font-size-2);
  color: #888;
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-6);
}

.DataConsent:deep(a) {
  color: var(--brand-color);
}

.DataConsent:deep(a:hover) {
  filter: brightness(0.85);
}
</style>
